import { Drawer } from "antd";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { workflowClient } from "../../../../store/graphql/apollo/clients";
import { LineChart, Line, CartesianGrid, XAxis, YAxis, ResponsiveContainer } from "recharts";
import { useUpdateTaskToCompleteMutation } from "../../../../store/graphql/codegen/auto-gen/workflow";

const data = [
  { name: "Jan", value1: 4000, value2: 2400 },
  { name: "Feb", value1: 3000, value2: 1398 },
  { name: "Mar", value1: 2000, value2: 9800 },
  { name: "Apr", value1: 2780, value2: 3908 },
  { name: "May", value1: 1890, value2: 4800 },
  { name: "Jun", value1: 2390, value2: 3800 },
  { name: "Jul", value1: 3490, value2: 4300 },
];
const SimulationLayout = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(true);
  const [updateTask] = useUpdateTaskToCompleteMutation({
      client: workflowClient,
      fetchPolicy: "no-cache",
      context: {
          headers: {
              Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE3MzI4ODMwMDQsImV4cCI6MTc2NDQxOTAwNCwiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoianJvY2tldEBleGFtcGxlLmNvbSIsIkdpdmVuTmFtZSI6IkpvaG5ueSIsIlN1cm5hbWUiOiJSb2NrZXQiLCJFbWFpbCI6Impyb2NrZXRAZXhhbXBsZS5jb20iLCJSb2xlIjpbIk1hbmFnZXIiLCJQcm9qZWN0IEFkbWluaXN0cmF0b3IiXX0.EdXw9v7kfLEp7cmJNh7g4Mnb91N2Cs5Bbh4xHZGvWxA`
          }
      },
  });
  const query = new URLSearchParams(useLocation().search);

  useEffect(() => {
    const runtimeId = query.get("runtimeId");

    if(runtimeId){
      updateTask({
        variables: {
          input: {
            runtimeWorkflowId: runtimeId,
            taskName: "wait_for_user_action",
            message: ""
          }
        },
        onCompleted: (data) => {
          console.log(data);
        },
        onError: (error) => {
          console.log(error);
        },
      });
    }
  }, []);

  return (
    <div>
      <Dashboard />
        <Drawer
          title="Invitation Simulation Complete"
          placement="right"
          onClose={() => setDrawerOpen(false)}
          open={isDrawerOpen}
          width={600}
          bodyStyle={{ padding: "20px" }}
        >
                    <div style={{
                backgroundColor: '#D0F3E0',
                padding: '5px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
            }}>
                <span style={{ fontSize: '35px', color: '#333', fontWeight: 'bold', paddingLeft: '2vw' }}>🎉</span>
                <span style={{ marginLeft: '20px', color: '#333', fontSize: '17px' }}>
                    <strong>Congratulations!</strong> Invitation Simulation is complete.
                </span>
            </div>
                      <div className="p-6 font-sans text-gray-800">
                        <p className="">
                          This is a simulated example of how the invited users will land on your product’s homepage or invited page after accepting an invitation.
                        </p>
                        <p className="mt-2">
                          From here, you can start integrating this service with your application. Head back to <span className="font-semibold">ThriveStack</span> to configure and customize the invitation system for your app.
                        </p>
                        <p className="mt-4 font-semibold">Ready to get started? 🚀</p>
                      </div>
        </Drawer>
    </div>
  );
};

const Dashboard = () => {
  return (
    <div className="flex min-h-screen bg-[rgba(249,250,251,0.8)] backdrop-blur-md">
      {/* Sidebar */}
      <div className="w-20 bg-gray-200 p-5 text-center shadow-lg fixed h-full opacity-70">
        <div className="mb-4">
          <img src="/favicon-192x192.png" alt="Acme Labs" className="w-10 h-10 mx-auto rounded-full mb-4" />
        </div>
        <hr />
        <div className="mt-6 space-y-10">
          <div className="text-2xl">🏠</div>
          {[1, 2, 3, 4].map((_, index) => (
            <div key={index} className="text-2xl">👤</div>
          ))}
        </div>
      </div>

      <div className="flex-grow ml-20 p-8 w-full opacity-50">
        <div className="grid gap-6">
          {/* Learn Section */}
          <div className="bg-white shadow-md rounded-lg p-6 w-11/12 mx-auto">
            <h2 className="font-semibold text-gray-700 text-lg">Learn</h2>
            <div className="flex justify-between mt-4">
              {[1, 2].map((_, index) => (
                <div key={index} className="bg-gray-200 w-1/3 h-20 rounded-md"></div>
              ))}
            </div>
          </div>

          {/* Things to Do Section */}
          <div className="bg-white shadow-md rounded-lg p-6 w-11/12 mx-auto">
            <h2 className="font-semibold text-gray-700 text-lg">Things to do</h2>
            <div className="grid gap-4 mt-4">
              {[
                { id: "01", count: 6465, avatar: "/path-to-avatar-1" },
                { id: "02", count: 5665, avatar: "/path-to-avatar-2" },
                { id: "03", count: 1755, avatar: "/path-to-avatar-3" },
              ].map((item) => (
                <div key={item.id} className="grid grid-cols-12 items-center gap-4">
                  <div className="col-span-1 text-gray-600 font-semibold">{item.id}</div>
                  <div className="col-span-2 text-gray-700 font-semibold">{item.count}</div>
                  <div className="col-span-2">
                    <img src={item.avatar} alt={`User ${item.id}`} className="w-10 h-10 rounded-full" />
                  </div>
                  <div className="col-span-7">
                    <div className="bg-gray-200 h-3 rounded-md"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Usage Section */}
          <div className="bg-white shadow-md rounded-lg p-6 w-11/12 mx-auto">
            <h2 className="font-semibold text-gray-700 text-lg">Usage</h2>
            <div className="mt-6">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
                  <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
                      <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis tickFormatter={(value) => `$${value / 1000}k`} />
                  <Line
                    type="monotone"
                    dataKey="value1"
                    stroke="#8884d8"
                    strokeWidth={3}
                    fill="url(#colorUv)"
                    fillOpacity={1}
                  />
                  <Line
                    type="monotone"
                    dataKey="value2"
                    stroke="#888888"
                    strokeDasharray="5 5"
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimulationLayout;
